
import { Component, Vue, Prop } from 'vue-property-decorator';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';
import imageConvert from '@/utils/image';

const { exchanger } = api;

@Component({
  components: { },
})
export default class VirtualExchangerForm extends Vue {
  @Prop({ default: '' }) exchangerId!: string;

  private loading: boolean = false;

  private valid: boolean = false;

  private pic: string = '';

  private form = {
    name: '',
    exchangerCode: '',
    pic: '',
    serviceFee: 0,
    serviceFeePercentage: 0,
    tradeFeePercentage: 0,
    isTradable: true,
    isTradingAllDay: false,
  }

  private get isEdit() {
    return !!this.exchangerId;
  }

  private get title() {
    return this.isEdit ? '修改' : '新增';
  }

  private rules = {
    name: [this.requiredRule('名稱')],
    exchangerCode: [this.requiredRule('簡稱')],
    pic: [...this.requiredFileRule()],
    serviceFee: [this.requiredRule('手續費')],
    serviceFeePercentage: [this.requiredRule('手續費百分比')],
    tradeFeePercentage: [this.requiredRule('交易手續費百分比')],
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private requiredFileRule() {
    return [
      (v: any) => !!v || !!this.pic || '檔案 為必填',
      (v: any) => !v || v.size < 4000000 || '照片大小不可大於 4 MB!',
    ];
  }

  private changePic(event: any) {
    if (event) {
      this.form.pic = event;
      this.pic = URL.createObjectURL(event);
    }
  }

  private clearImage() {
    this.pic = '';
    this.form.pic = '';
  }

  private async cancel() {
    await this.$router.back();
  }

  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      const data = {
        ...this.form,
        pic: await imageConvert(this.form.pic as any),
      };
      const { status } = this.isEdit
        ? await exchanger.edit(this.exchangerId, data)
        : await exchanger.add(data);
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: `${this.title}成功` });
        this.$router.back();
      }
    }
  }

  private async mounted() {
    if (this.isEdit) {
      const { data } = await exchanger.get(this.exchangerId);
      this.form = data;
      this.pic = this.form.pic;
    }
  }
}
